import { createApiClient } from './apiClient';
import { API_BASE_URL } from '../config';

export type SatoshiAccountProfile = {
  _id: string;
  name: string;
  exchangeClients?: unknown[];
};

export type SatoshiAccountNotification = {
  _id: string;
  info?: string;
  time?: string;
};

type SatoshiAccountResponse = {
  success: boolean;
  data?: SatoshiAccountProfile[];
  notifications?: SatoshiAccountNotification[];
  message?: string;
};

const satoshiAccountApi = createApiClient({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

export async function fetchSatoshiAccount(
  token: string | null,
  tgChatId: string | undefined
): Promise<SatoshiAccountResponse> {
  const headers: Record<string, string> = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const resp = await satoshiAccountApi.get<SatoshiAccountResponse>('/satoshi-account', {
    headers,
    params: tgChatId ? { tg_chat_id: tgChatId } : undefined,
  });
  return resp.data;
}
